import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgSmartphoneShare = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 48,
  viewBox: "0 0 49 48",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("rect", {
    width: 48,
    height: 48,
    x: 0.333,
    fill: "#ECECEC",
    rx: 24
  }), /*#__PURE__*/_jsx("path", {
    fill: "#504C49",
    fillRule: "evenodd",
    d: "M17.667 9.334 31 9.347A2.663 2.663 0 0 1 33.667 12v24c0 1.467-1.2 2.667-2.667 2.667H17.667A2.674 2.674 0 0 1 15 36V12c0-1.466 1.2-2.666 2.667-2.666m0 24H31V14.667H17.667z",
    clipRule: "evenodd"
  })]
});
export default SvgSmartphoneShare;